import request from './request';

export function createPost(data) {
  return request.post('/api/post/create', data);
}
export function getMyPosts(params) {
  return request.get('/api/post/myPosts', { params });
}
export function getFeed(params) {
  return request.get('/api/post/feed', { params });
}
export function likePost(postId) {
  return request.post('/api/post/like', { post_id: postId });
}
export function unlikePost(postId) {
  return request.post('/api/post/unlike', { post_id: postId });
}
export function deletePost(id) {
  return request.post('/api/post/delete', { id });
}

// 动态评论
export function getPostComments(params) {
  return request.get('/api/post/comments', { params });
}
export function addPostComment(data) {
  return request.post('/api/post/addComment', data);
}
export function deletePostComment(commentId) {
  return request.post('/api/post/deleteComment', { comment_id: commentId });
}
export function likePostComment(commentId) {
  return request.post('/api/post/likeComment', { comment_id: commentId });
}
export function unlikePostComment(commentId) {
  return request.post('/api/post/unlikeComment', { comment_id: commentId });
}
